import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Master Excel: Il Correttore Automatico',
  price: '€67',
  desc: 'Fogli di calcolo che correggono bilanci e verifiche al posto tuo. Inserisci i dati, il file fa il resto.'
}, {
  num: '2',
  title: 'Banca delle Verifiche: 25 Test Pronti con Soluzioni',
  price: '€47',
  desc: 'Verifiche sommative già pronte per ogni modulo. Stampa e distribuisci.'
}, {
  num: '3',
  title: 'Kit Griglie di Valutazione Oggettive',
  price: '€47',
  desc: 'Griglie conformi MIM compatibili con ClasseViva, Argo e Axios.'
}, {
  num: '4',
  title: 'Le 33 ore di Educazione Civica: 10 Lezioni PPT Pronte',
  price: '€37',
  desc: 'Le ore obbligatorie già pianificate e documentate per il registro.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-29">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-30" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-32">
          <div className="bg-brand-orange/20 p-4 rounded-full mb-4" data-id="element-33">
            <GiftIcon className="w-10 h-10 text-brand-orange" data-id="element-34" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream" data-id="element-35">
            4 Bonus Strategici <span className="text-brand-gold" data-id="element-36">Inclusi</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-37">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_20px_rgba(249,115,22,0.1)]" data-id="element-38">
              <div className="flex items-start justify-between gap-3 mb-4" data-id="element-39">
                <div className="flex items-center gap-3" data-id="element-40">
                  <span className="text-2xl" data-id="element-41">🎁</span>
                  <h3 className="text-lg sm:text-xl font-bold text-brand-gold leading-tight" data-id="element-42">
                    Bonus {bonus.num} — {bonus.title}
                  </h3>
                </div>
                <span className="text-brand-orange font-black text-base shrink-0" data-id="element-43">
                  {bonus.price}
                </span>
              </div>
              <p className="text-gray-300 font-medium leading-relaxed" data-id="element-44">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center bg-brand-card border border-brand-gold/40 rounded-2xl py-4 px-5" data-id="element-45">
          <p className="text-brand-cream font-black text-base sm:text-lg" data-id="element-46">
            💎 VALORE TOTALE DEI 4 BONUS:{' '}
            <span className="text-brand-gold" data-id="element-47">€198</span>
          </p>
        </motion.div>
      </div>
    </section>;
}